import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const INTAKE_EXEMPT_PATH_PATTERN = /^\/fitness-profiles\/\d+\/complete-intake$/;

export default function HouseholdIntakeGate({ children }) {
	const { activeFitnessProfile } = useAuth();
	const location = useLocation();

	if (activeFitnessProfile?.intake_required) {
		const isExempt = INTAKE_EXEMPT_PATH_PATTERN.test(location.pathname);
		if (!isExempt) {
			return (
				<Navigate
					to={`/fitness-profiles/${activeFitnessProfile.id}/complete-intake`}
					replace
				/>
			);
		}
	}

	return children;
}
